import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import "../../assets/css/tools.css";
import loadingGif from "../../assets/images/loading.gif";
import FilePondPluginFileEncode from "filepond-plugin-file-encode";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileEncode
);
Modal.setAppElement("#root");

class Tools_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applicationLinks: [],
      isLoading: true,
      linkModal: false,
      //   linkModal: true,
      title: "",
      url: "",
      files: [],
      linkPosted: false,
      //   linkPosted: true,
      linkImagePosted: false,
      postedLinkID: null,
    };
    this.globalStorage = this.props.globalStorage;
    this.config = {
      headers: {
        Authorization: JSON.parse(localStorage.getItem("tokenAdmin")),
      },
    };
  }

  componentDidMount = () => {
    this.getApplicationLinks();
  };

  getApplicationLinks = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/application_links`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        const snjobLink = res.data.find(
          (link) => link.url === "https://noavaran-sharif.ir/"
        );
        if (snjobLink !== undefined) {
          const links = [
            snjobLink,
            ...res.data.filter(
              (link) => link.url !== "https://noavaran-sharif.ir/"
            ),
          ];
          this.setState({ isLoading: false, applicationLinks: links });
        } else {
          this.setState({ isLoading: false, applicationLinks: res.data });
        }
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  postApplicationLinks = () => {
    const { title, url, files } = this.state;
    const data = {
      name: title,
      url,
      image: files[0].file,
    };

    this.props
      .dispatch(
        userActions.API(
          "post",
          `v1/sub_admin/hospital/application_links`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.reset();
        this.setState({ postedLinkID: res.data.id });
        this.getApplicationLinks();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  deleteApplicationLinks = (id) => {
    this.props
      .dispatch(
        userActions.API(
          "delete",
          `v1/sub_admin/hospital/application_links/${id}`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.getApplicationLinks();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handleFileUpload = (fileItems) => {
    this.setState({
      files: fileItems.map((fileItem, i) => {
        return {
          file: `data:${
            fileItem.file.type
          };base64,${fileItem.getFileEncodeBase64String()}`,
        };
      }),
    });
  };

  reset = () => {
    this.setState({
      linkModal: false,
      title: "",
      url: "",
      files: [],
      postedLinkID: null,
    });
  };

  render() {
    const {
      dispatch,
      postApplicationLinks,
      deleteApplicationLinks,
      handleFileUpload,
    } = this;
    const {
      isLoading,
      applicationLinks,
      linkModal,
      title,
      url,
      linkPosted,
      linkImagePosted,
      files,
    } = this.state;
    return (
      <div className="container-fluid px-5 pb-5 mt-3 tools">
        <div className="row">
          <div className="col-lg-9 col-md-12 m-auto">
            <List onOpen={() => this.setState({ linkModal: true })}>
              {isLoading ? (
                <Loading />
              ) : applicationLinks.length ? (
                applicationLinks.map((link, i) => (
                  <ListItem
                    i={i}
                    key={i + 1}
                    link={link}
                    onDelete={() =>
                      this.props
                        .dispatch(
                          userActions.question("حذف", "آیا از حذف مطمئن هستید؟")
                        )
                        .then((r) => {
                          if (r.value) {
                            deleteApplicationLinks(link.id);
                          }
                        })
                    }
                  />
                ))
              ) : (
                <EmptyListItem />
              )}
            </List>
            <Modal
              isOpen={linkModal}
              contentLabel="Monitor Modal"
              portalClassName="full_screen_modal"
            >
              <ModalPartners
                title={title}
                url={url}
                files={files}
                linkPosted={linkPosted}
                linkImagePosted={linkImagePosted}
                dispatch={dispatch}
                onClose={() => this.setState({ linkModal: false })}
                onPost={postApplicationLinks}
                handleFileUpload={handleFileUpload}
                onTitle={(e) => this.setState({ title: e.target.value })}
                onUrl={(e) => this.setState({ url: e.target.value })}
              />
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

class ModalPartners extends Component {
  componentDidMount = () => {
    document.querySelector(".logout-btn").classList.add("hidden");
    document.querySelector(".logout-btn-bg").classList.add("hidden");
  };

  componentWillUnmount = () => {
    document.querySelector(".logout-btn").classList.remove("hidden");
    document.querySelector(".logout-btn-bg").classList.remove("hidden");
  };

  render() {
    const {
      onClose,
      onPost,
      title,
      url,
      dispatch,
      files,
      linkPosted,
      handleFileUpload,
      onTitle,
      onUrl,
    } = this.props;

    return (
      <div className="modal--add-link tools_container">
        {!linkPosted ? (
          <>
            <div className="row col-lg-12 col-md-12 banner">
              <p>افزودن نرم افزار</p>
              <button onClick={onClose}>&#10005;</button>
            </div>
            <div className="w-100 mt-4 px-4">
              <p className="text-right w-100 text_style mb-2 px-3">نام لینک</p>
              <Input
                value={title}
                onChange={onTitle}
                placeholder="نام لینک را انتخاب کنید"
              />
            </div>

            <div className="w-100 mt-4 px-4">
              <p className="text-right w-100 text_style px-3 d-inline-block mb-2 mt-3">
                URL
              </p>
              <Input
                value={url}
                onChange={onUrl}
                placeholder="URL را انتخاب کنید"
              />
            </div>

            <div style={{ marginBottom: "100px" }} className="w-100 mt-4 px-4">
              <p className="text-right w-100 text_style px-3 d-inline-block mb-2 mt-3">
                بارگذاری فایل برای این خبر
              </p>
              <div className="row justify-content-center file_container mx-auto">
                <div
                  className="d-flex flex-column attachFile container shadow guide"
                  style={{
                    borderRadius: "20px",
                    padding: "10px 10px 0 10px",
                    color: "#104C82",
                  }}
                >
                  <p className="text-center m-0 text_style">
                    فایـل را بکشیـد و رهـا کنیـد
                  </p>
                  <FilePond
                    files={files}
                    allowReorder={false}
                    allowMultiple={false}
                    onupdatefiles={handleFileUpload}
                    allowFileEncode={true}
                    labelIdle="گالری تصاویر"
                  />
                  <p
                    style={{
                      margin: 0,
                      padding: "25px 30px 30px 30px",
                      textAlign: "center",
                    }}
                  >
                    حداکثـر حجـم بارگـذاری فایـل 20MB می باشـد
                  </p>
                </div>
              </div>
            </div>
            <div className="row col-lg-12 footer">
              <button
                onClick={() => {
                  if (title.length === 0) {
                    return userActions.failure(
                      "لطفا نام نرم افزار را انتخاب کنید"
                    );
                  } else if (url.length === 0) {
                    return userActions.failure(
                      "لطفا لینک نرم افزار را انتخاب کنید"
                    );
                  } else if (files === undefined || files.length === 0) {
                    return userActions.failure(
                      "لطفا لوگو نرم افزار را انتخاب کنید"
                    );
                  }
                  onPost();
                }}
              >
                ثبت
              </button>
              <button className="ghost" onClick={onClose}>
                بازگشت
              </button>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class Input extends Component {
  render() {
    const { value, onChange, placeholder } = this.props;
    return (
      <input
        name="name"
        type="text"
        className="form-control"
        aria-label="Full Name"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    );
  }
}

class EmptyListItem extends Component {
  render() {
    return (
      <li className="tools__list__item empty-list">
        <p className="tools__list__item__text empty-list__child">
          برای نمایش اطلاعات از دکمه های بالا استفاده نمایید
        </p>
      </li>
    );
  }
}

class List extends Component {
  render() {
    const { onOpen } = this.props;

    return (
      <div className="list-wrapper">
        <ul className="tools__list">
          <Banner />
          {this.props.children}
        </ul>
        <button
          className="btn btn-primary rounded-pill mt-3 btn_requestcheck d-flex justify-content-center mx-auto py-2"
          onClick={onOpen}
        >
          افزودن
        </button>
      </div>
    );
  }
}

class Banner extends Component {
  render() {
    return (
      <li className="tools__list__banner" key="0">
        <div className="tools__list__banner__child">ردیف</div>
        <div className="tools__list__banner__child">نام لینک</div>
        <div className="tools__list__banner__child">تصویر</div>
        <div className="tools__list__banner__child">عملیـات</div>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    // if (this.props.news === undefined) return null;

    const { i, link, onDelete } = this.props;
    const {
      id,
      name,
      image,
      url,
      application_link_id,
      hospital_id,
      created_at,
      updated_at,
    } = link;

    return (
      <li className={`tools__list__item`}>
        <ListItemBtnContainer>
          <p className="tools__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="tools__list__item__text">{name}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <img
            src={`${userConstants.SERVER_URL}${image.url}`}
            className="btn-round"
          />
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          {/* <BtnRound
            className="edit-icon"
            // onClick={() => dispatch({ type: "handle news modal", payload: id })}
          /> */}
          {url !== "https://noavaran-sharif.ir/" ? (
            <BtnRound className="delete-icon" onClick={onDelete} />
          ) : (
            ""
          )}
        </ListItemBtnContainer>
      </li>
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <button
        className={`btn-round ${this.props.className}`}
        onClick={this.props.onClick}
        data-tip={this.props.data_tip}
      ></button>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div className="tools__list__item__btn-container">
        {this.props.children}
        {/* <ReactTooltip type="dark" /> */}
      </div>
    );
  }
}

class Loading extends Component {
  render() {
    return (
      <li className="tools__list__item empty-list">
        <img src={loadingGif} style={{ width: "160px" }} />
      </li>
    );
  }
}

const Tools = connect((state) => ({
  globalStorage: state.globalStorage,
}))(Tools_);

export { Tools };
